// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ApplicationMenuAction } from "../../../components/ApplicationMenu/ApplicationMenuAction";
import { ApplicationMenuActionItem } from "../../../components/ApplicationMenu/ApplicationMenuActionItem";
import { SpeedDialDataProvider } from "./SpeedDialDataProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const SpeedDialMenu = props => {
  const {
    module
  } = props;
  const getSpeedDial = React.useCallback(buttons => _.map(buttons, ({
    identifiant,
    titre,
    icone,
    adresse,
    onClick
  }) => /*#__PURE__*/_jsx(ApplicationMenuActionItem, {
    identifiant: identifiant,
    title: titre,
    icon: icone,
    path: adresse,
    onClick: onClick
  }, identifiant)), []);
  const renderSpeedDialProvider = React.useCallback(speedial => /*#__PURE__*/_jsx(ApplicationMenuAction, {
    actions: getSpeedDial(speedial?.buttons)
  }, "speedial"), [getSpeedDial]);
  return React.useMemo(() => /*#__PURE__*/_jsx(SpeedDialDataProvider, {
    module: module,
    children: renderSpeedDialProvider
  }), [module, renderSpeedDialProvider]);
};